import React, { useState, useRef, useEffect , useReducer} from "react";
import { Modal } from "react-bootstrap";
import { GlobalSet } from '../../global/GlobalProvider';
import { QRCodeCanvas } from "qrcode.react";
import { Link } from "react-router-dom";
import axios from "axios";
//lg
import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';


//** Import Image */
const BasicDatatable = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(
    document.querySelectorAll("#job_data tbody tr")
  );

/** Link */
const initialState = false;
const reducer = (state, action) =>{
  switch (action.type){
    case 'linkModal':
      return { ...state, link: !state.link }    
    default:
      return state  
  } 
}

  const { CurrencySymbol } = GlobalSet();
  const sort = 5;
  const activePag = useRef(0);
  //const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#job_data tbody tr"));
   // chackboxFun();
  }, []);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    //settest(i);
  };

  const [selectedTeam, setSelectedTeam] = useState(''); // State for selected team

  const handleTeamChange = (event) => {
    setSelectedTeam(event.target.value);
  };


 /*.....income data......*/

 const [income, setIncome] = useState([]);
 const [inmydata, MyData] = useState([]);
    useEffect(()=>{
      const auth_token = localStorage.getItem('auth_token');
        const data = {
            key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
        }
      if (auth_token !== null) {
         axios.post('/apps-my-sponsor',data)
         .then(response=>{
           setIncome(response.data.data);
           MyData(response.data.mydata)
           
           })
           .catch(error=>{
             console.log(error)
         })
      }

    },[])


  const [isCopySuccess, setIsCopySuccess] = useState(false);
  const [isRCopySuccess, setIsRCopySuccess] = useState(false);

  const handleCopyClick = () => {
    const linkToCopy = "https://segma.app/affiliate.html?ref=" + inmydata.reference_code + "&team="+ selectedTeam;
    navigator.clipboard.writeText(linkToCopy)
      .then(() => {
        setIsCopySuccess(true);
        setTimeout(() => {
          setIsCopySuccess(false);
        }, 3000); // 3000 milliseconds (3 seconds)
      })
      .catch((error) => {
        console.error('Error copying to clipboard:', error);
      });
  };

  const handleRCopyClick = () => {
    const linkToCopy = inmydata.reference_code;
    navigator.clipboard.writeText(linkToCopy)
      .then(() => {
        setIsRCopySuccess(true);
        setTimeout(() => {
          setIsRCopySuccess(false);
        }, 3000); // 3000 milliseconds (3 seconds)
      })
      .catch((error) => {
        console.error('Error copying to clipboard:', error);
      });
  };



//** qr code */
  const [url, setUrl] = useState("");
  const qrRef = useRef();
  const downloadQRCode = (e) => {
    e.preventDefault();
    let canvas = qrRef.current.querySelector("canvas");
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `qr-code.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setUrl("");
  };
  const qrCodeEncoder = (e) => {
    setUrl(e.target.value);
  };

  const qrcode = (
    <QRCodeCanvas
      id="qrCode"
      value={"https://segma.app/affiliate.html?share?ref="+inmydata.reference_code + "&team="+ selectedTeam}
      size={200}
      bgColor={"#000fff00"}
      level={"H"}
    />
  );



  const onInit = () => {
    //console.log('lightGallery has been initialized');
  };
    const options = {
      settings: {
      overlayColor: "#000000",
      },
  };
  const [state, dispatch] = useReducer(reducer, initialState);



  return (
    <div className="col-12">


           <div className="col-xl-12">
  <div className="row">

    {/* Left Side: Referral Link & Share Buttons */}
    <div className="col-xl-6 col-sm-12 mb-4">
      <div className="card shadow border-0" style={{ background: "linear-gradient(135deg, #f0f4ff, #e0e7ff)" }}>
        <div className="card-body">

          {/* Team Select Dropdown */}
          <div className="mb-4">
            <label className="form-label fw-bold">Select Your Team</label>
            <select className="form-select" value={selectedTeam} onChange={handleTeamChange}>
              <option value="">Select team</option>
              <option value="a">Team A</option>
              <option value="b">Team B</option>
              <option value="c">Team C</option>
            </select>
          </div>

          {/* Referral Link with Copy Button */}
          <div className="mb-4">
            <label className="form-label fw-bold">Referral Link</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={`https://segma.app/affiliate.html?ref=${inmydata.reference_code}&team=${selectedTeam}`}
                readOnly
              />
              <button className="btn btn-outline-primary" onClick={handleCopyClick}>
                {t('pro_affi_copy_link')}
              </button>
            </div>
            {isCopySuccess && <small className="text-success">Link copied successfully!</small>}
          </div>

          {/* Referral Code with Copy Button */}
          <div className="mb-4">
            <label className="form-label fw-bold">Your Referral Code</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={inmydata.reference_code}
                readOnly
              />
              <button className="btn btn-outline-success" onClick={handleRCopyClick}>
                {t('pro_affi_copy_link_cd')}
              </button>
            </div>
            {isRCopySuccess && <small className="text-success">Code copied successfully!</small>}
          </div>

          {/* Social Share Buttons */}
          <div className="text-center mt-5">
            <h6 className="fw-bold mb-3 text-primary">{t('pro_affi_s_s_l')}</h6>
            <div className="d-flex flex-wrap justify-content-center gap-3">
              <a href={`https://api.whatsapp.com/send/?text=Please+register+here.+https://segma.app/affiliate.html?share?ref=${inmydata.reference_code}`} className="btn btn-success rounded-circle" style={{ fontSize: "24px" }}>
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href={`https://pinterest.com/pin/create/button/?url=Please+register+here.+https://segma.app/affiliate.html?share?ref=${inmydata.reference_code}`} className="btn btn-danger rounded-circle" style={{ fontSize: "24px" }}>
                <i className="fab fa-pinterest"></i>
              </a>
              <a href={`https://twitter.com/intent/tweet?url=Please+register+here.+https://segma.app/affiliate.html?share?ref=${inmydata.reference_code}`} className="btn btn-info rounded-circle" style={{ fontSize: "24px" }}>
                <i className="fab fa-twitter"></i>
              </a>
              <a href={`https://t.me/share/url?url=Please+register+here.+https://segma.app/affiliate.html?share?ref=${inmydata.reference_code}`} className="btn btn-primary rounded-circle" style={{ fontSize: "24px" }}>
                <i className="fab fa-telegram"></i>
              </a>
              <a href={`https://www.facebook.com/sharer/sharer.php?u=Please+register+here`} className="btn btn-primary rounded-circle" style={{ fontSize: "24px", backgroundColor: "#3b5998" }}>
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href={`https://plus.google.com/share?url=https://segma.app/affiliate.html?share?ref=${inmydata.reference_code}`} className="btn btn-danger rounded-circle" style={{ fontSize: "24px" }}>
                <i className="fab fa-google-plus-g"></i>
              </a>
              <a href={`https://www.linkedin.com/shareArticle?mini=true&url=Please+register+here.+https://segma.app/affiliate.html?share?ref=${inmydata.reference_code}`} className="btn btn-primary rounded-circle" style={{ fontSize: "24px", backgroundColor: "#0077b5" }}>
                <i className="fab fa-linkedin"></i>
              </a>
              <a href={`https://www.tumblr.com/widgets/share/tool/preview?shareSource=legacy&url=https://segma.app/affiliate.html?share?ref=${inmydata.reference_code}`} className="btn btn-dark rounded-circle" style={{ fontSize: "24px" }}>
                <i className="fab fa-tumblr"></i>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>

    {/* Right Side: QR Code Download */}
    <div className="col-xl-6 col-sm-12 mb-4">
      <div className="card shadow border-0" style={{ background: "linear-gradient(135deg, #e0ffe0, #d0ffd0)" }}>
        <div className="card-body d-flex flex-column align-items-center justify-content-center">

          {/* QR Code */}
          <div className="bg-white p-3 rounded mb-3" ref={qrRef}>
            {qrcode}
          </div>

          {/* Download QR Button */}
          <form onSubmit={downloadQRCode}>
            <button type="submit" className="btn btn-outline-success fw-bold">
              {t('pro_affi_dow_qe')}
            </button>
          </form>

        </div>
      </div>
    </div>

  </div>
</div>



<div className="col-xl-12">
  <div className="row g-4">

    {/* Total Active Users */}
    <div className="col-xl-6 col-sm-12">
      <div className="card shadow-sm border-0" style={{ background: "linear-gradient(135deg, #fef9f7, #fce9e6)", transition: "0.3s" }}>
        <div className="card-body d-flex align-items-center">
          
          {/* Icon */}
          <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px", backgroundColor: "#ffe3d3" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ff7e47" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>

          {/* Text */}
          <div className="ms-4">
            <h4 className="mb-1 fw-bold text-dark">{inmydata.count_active_spons} Users</h4>
            <p className="mb-0 text-muted small">{t('pro_affi_t_r_u')}</p>
          </div>

        </div>
      </div>
    </div>

    {/* Team Sales */}
    <div className="col-xl-6 col-sm-12">
      <div className="card shadow-sm border-0" style={{ background: "linear-gradient(135deg, #f1f8ff, #d9eefe)", transition: "0.3s" }}>
        <div className="card-body d-flex align-items-center">

          {/* Icon */}
          <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px", backgroundColor: "#d2e9ff" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>

          {/* Text */}
          <div className="ms-4">
            <h4 className="mb-1 fw-bold text-dark">${inmydata.team_sell}</h4>
            <p className="mb-0 text-muted small">My Team Sales</p>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

<div className="card border-0 shadow-sm">
  <div className="card-header bg-info text-white">
    <h4 className="card-title mb-0">{t('pro_affi_sp_his')}</h4>
  </div>
  
  <div className="card-body">
    <div className="table-responsive">
      <div id="job_data" className="dataTables_wrapper">
        
        <table className="table table-hover align-middle mb-0">
          <thead className="bg-light text-dark">
            <tr>
              <th scope="col">SL</th>
              <th scope="col">{t('pro_affi_name')}</th>
              <th scope="col">Email</th>
              <th scope="col">Self Sell</th>
              <th scope="col">Self + Team</th>
              <th scope="col">Team Sell</th>
              <th scope="col">{t('pro_affi_date')}</th>
            </tr>
          </thead>

          <tbody>
            {income.map((incomerow, index) => (
              <tr key={incomerow.id}>
                <td><strong>{index + 1}</strong></td>
                <td>{incomerow.name === null ? <span className="badge bg-warning">Not Verified</span> : incomerow.name}</td>
                <td>{incomerow.email}</td>
                <td><span className="badge bg-success">${incomerow.total_invest}</span></td>
                <td><span className="badge bg-info">${incomerow.team_and_spon_sell}</span></td>
                <td><span className="badge bg-primary">${incomerow.team_sell}</span></td>
                <td>{incomerow.created_at}</td>
              </tr>
            ))}
          </tbody>

        </table>

        {/* Pagination + Info */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
          
          {/* Entries Info */}
          <div className="text-muted small mb-2 mb-md-0">
            Showing {activePag.current * sort + 1} to{" "}
            {data.length > (activePag.current + 1) * sort
              ? (activePag.current + 1) * sort
              : data.length}{" "}
            of {data.length} entries
          </div>

          {/* Pagination */}
          <nav>
            <ul className="pagination pagination-sm mb-0">
              <li className={`page-item ${activePag.current === 0 ? "disabled" : ""}`}>
                <Link
                  className="page-link"
                  to="/mysponsor-history"
                  onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}
                >
                  «
                </Link>
              </li>

              {paggination.map((number, i) => (
                <li key={i} className={`page-item ${activePag.current === i ? "active" : ""}`}>
                  <Link
                    to="/mysponsor-history"
                    className="page-link"
                    onClick={() => onClick(i)}
                  >
                    {number}
                  </Link>
                </li>
              ))}

              <li className={`page-item ${activePag.current + 1 >= paggination.length ? "disabled" : ""}`}>
                <Link
                  className="page-link"
                  to="/mysponsor-history"
                  onClick={() => activePag.current + 1 < paggination.length && onClick(activePag.current + 1)}
                >
                  »
                </Link>
              </li>
            </ul>
          </nav>

        </div>

      </div>
    </div>
  </div>
</div>


      {/* <div className="card">
        <div className="card-header">
          <h4 className="card-title">{t('pro_affi_sp_his')}</h4>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table
                className="display w-100 dataTable "
                id="example5"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr role="row">
                    <th className="sorting_asc" style={{ width: "177px" }}>
                      SL
                    </th>
                    <th className="sorting_asc" style={{ width: "177px" }}>
                      {t('pro_affi_name')}
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Email
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Self Sell
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Self And Team
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Team Sell
                    </th>
                    <th className="sorting" style={{ width: "128px" }}>
                      {t('pro_affi_date')}
                    </th>
                  </tr>
                </thead>

                <tbody>
                {income.map((incomerow, index)=>(
                  <tr key={incomerow.id} className="odd" role="row">
                    <td className="sorting_1">{index + 1}</td>
                    <td className="sorting_1">{incomerow.name ===null ? "Not Verified" : incomerow.name}</td>
                    <td>{incomerow.email}</td>
                    <td>${incomerow.total_invest}</td>
                    <td>${incomerow.team_and_spon_sell}</td>
                    <td>${incomerow.team_sell}</td>
                    <td>{incomerow.created_at}</td>
                  </tr>
                  ))}
                </tbody>
               

              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-md-0 mb-2">
                <div className="dataTables_info">
                  Showing {activePag.current * sort + 1} to{" "}
                  {data.length > (activePag.current + 1) * sort
                    ? (activePag.current + 1) * sort
                    : data.length}{" "}
                  of {data.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers mb-0"
                  id="example5_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    to="/mysponsor-history"
                    onClick={() =>
                      activePag.current > 0 && onClick(activePag.current - 1)
                    }
                  >
                    <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                  </Link>
                  <span>
                    {paggination.map((number, i) => (
                      <Link
                        key={i}
                        to="/mysponsor-history"
                        className={`paginate_button  ${
                          activePag.current === i ? "current" : ""
                        } `}
                        onClick={() => onClick(i)}
                      >
                        {number}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="/mysponsor-history"
                    onClick={() =>
                      activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1)
                    }
                  >
                    <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default BasicDatatable;
